export type ParseRawJsonResult =
  | { ok: true; variables: Record<string, unknown> }
  | { ok: false; error: string };

export const parseRawJsonVariables = (raw: string): ParseRawJsonResult => {
  const trimmed = raw.trim();

  if (!trimmed) {
    return { ok: false, error: "Please paste a JSON object" };
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return { ok: false, error: "Invalid JSON. Fix the syntax and try again." };
  }

  if (parsed === null || Array.isArray(parsed) || typeof parsed !== "object") {
    return {
      ok: false,
      error: 'JSON must be an object like { "key": "value" }',
    };
  }

  const entries = Object.entries(parsed as Record<string, unknown>);
  if (entries.length === 0) {
    return { ok: false, error: "JSON object has no keys" };
  }

  const invalidKey = entries.find(([key]) => !key.trim());
  if (invalidKey) {
    return { ok: false, error: "Variable keys cannot be empty" };
  }

  return { ok: true, variables: parsed as Record<string, unknown> };
};
